import React from 'react'
import { Link } from 'react-router-dom'

const IVRMainContent = () => {
    const JavascriptVoid = (event) => {
        event.preventDefault();
    };
    return (
        <>
            <section className="services-details-area ptb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 services-details">
                            <div className="ml-about-content">
                                {/* <h2>Quality IVR Service provider</h2> */}
                                <h1>Quality IVR Service Provider in Noida</h1>
                                <div className="bar" />
                                <p>
                                    IVR is the need for this advanced technological world. IVR
                                    (Interactive Voice Response system) is an important component for
                                    any business today. An IVR is a device that can help you to decrease
                                    your costs and increase customer satisfaction in your small or large
                                    business. But there is a need for every business to select the best IVR Service Providers in Noida for SMEs that meets the exclusive and
                                    significant needs of your Online /offline business. Alobha
                                    Technologies is the one best IVR Service provider in Noida, INDIA.
                                </p>
                                <h3>
                                    <b>Quick Response Call system</b>
                                </h3>
                                <p>
                                    Virtual Phone/IVR Number is a trending technology to support the
                                    business communication scale quicker and track better. A
                                    professional image of a business is created when you are using IVR
                                    services for your business. You have the full right to discover a
                                    powerful and convenient way to connect with your customers and
                                    prospects without infrastructure worries. There are lots of IVR
                                    services providers in the market but you have to find out the right
                                    one for your business who gives complete features and benefits of
                                    IVR services.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img
                                src="assets/img/service-detail-image/ivr.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="separate" />
                    <div className="row">
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Get familiar with IVR Features</b>
                                </h3>
                                <p>
                                    IVR Services provides a package of various advanced features for
                                    their valuable customers. Here are some of the features: -
                                </p>
                                <h5>Welcome Message</h5>
                                <p>
                                    An automated Welcome Message is run when you immediately connect to
                                    the IVR. This will greet the customer first and then ask them for
                                    the next step.
                                </p>
                                <h5>Call Tracking</h5>
                                <p>
                                    A lot of features are provided by IVR. It creates a simple and free
                                    of cost channel for customers to access you. Track your overall
                                    calls with a cloud-based telephone system. Avail our Virtual Number
                                    Service today!
                                </p>
                                <h5> Connect to the right client faster</h5>
                                <p>
                                    By the option, you can manage delay times proficiently by giving
                                    caller’s a choice from multi-tiered menus to connect to suitable
                                    clients or queues.
                                </p>
                                <h5> Easy CRM integration</h5>
                                <p>
                                    Get easy to use an IVR system and better communication with IVR that
                                    can convert text into speech. CRM is easily integrated with any of
                                    the IVR Numbers.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details">
                            <h5>Toll-free number</h5>
                            <p>
                                A complete toll-free number is provided with these services. So,
                                customers can directly reach you without any call charges.
                            </p>
                            <h5>Low-cost Services</h5>
                            <p>
                                All IVR services are available at cheap rates which are easy to buy.
                                They support a lot of features embedded in it.
                            </p>
                            <h5>Real-Time Reporting</h5>
                            <p>
                                You can track all live time calls and check the status of daily calls
                                with IVR Services. Interactive Voice Response is designed as per
                                customer needs.
                            </p>
                            <h5>Never Miss Any Call</h5>
                            <p>
                                If you are using IVR services you will never miss a call from any of
                                your potential customers. You can get a notification through emails
                                for every missed call.
                            </p>
                            <h5> Music on Hold</h5>
                            <p>
                                Waiting music will activate while your call is on hold or the customer
                                executive will be busy on another call.
                            </p>
                            <h5>Easy to set holiday and hours</h5>
                            <p>
                                This feature allows you to set any default voice message on holidays
                                or non-working hours of business. You can set it once and they apply
                                on calendar holidays.
                            </p>
                        </div>
                    </div>
                    <div className="separate" />
                    <div className="row align-items-center">
                        <div className="col-lg-6 services-details-image">
                            <img
                                src="assets/img/service-detail-image/ivr-2.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc mb-2">
                                <div className="ml-about-content">
                                    <h2>Benefits of using IVR Services</h2>
                                    <div className="bar" />
                                </div>
                                <div className="services-details-accordion">
                                    <ul className="accordion">
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                Use your brand number for promotions.
                                            </Link>
                                            {/* <p class="accordion-content show">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                You can get a Toll-free number in which installation is not
                                                required.
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                Easy Multi-Level IVR call traffic and direction-finding
                                                management
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                High availability &amp; capacity toll-free numbers
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                Easy SMS delivery
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 services-details-desc">
                            <h3>
                                <b>Automated Inbound &amp; Outbound Communication</b>
                            </h3>
                            <p>
                                There is a need for communication in every team to run your business
                                smoothly without gaps. We at Alobha, understand your business
                                communication needs. Our developer will integrate IVR Services in
                                business as per your requirements. IVR will track the complete
                                engagements and leads, support your CRM, and give you various latest
                                features. IVR Services will diminish your cost per call by letting
                                customers choose the type of assistance they want regarding their
                                query, such as self-service or speaking to a special executive, also
                                reducing waiting time and routing calls to the right manager.
                            </p>
                            {/* <h3>
                                <b>Take IVR Services from Alobha Technologies</b>
                            </h3> */}
                            <h2 style={{ fontSize: "20px", marginBottom: "15px", fontFamily: "Montserrat" }}>
                                <b>Take IVR Services from Alobha Technologies</b>
                            </h2>
                            <p>
                                Alobha Technologies is the finest IVR Services provider in Noida. Get
                                an easy to use and best IVR services for your communication purpose.
                                The toll-free number, welcome note services from IVR number providers
                                can be complemented with music and other feedback options.
                                Communication plays a key role in any business. Without healthy
                                communication, you cannot grow your business easily. IVR System is
                                diversified into various parts by which a concerned customer easily
                                gets their query solution. Customers can directly get their query
                                solution via computer-oriented voice notes. Pre-recorded music is
                                played when a customer calls and this music is available in all
                                languages. During high call Responses, it diverts to the right concern
                                person. Our IVR services also provide high values for all qualifying
                                customers.
                            </p>
                            <h3 style={{ fontSize: 17 }}>
                                Don’t worry, we will keep your customer privacy safe! Contact us
                            </h3>
                            <h4 style={{ fontSize: 17, fontFamily: "Montserrat" }}>Get the Best IVR Services from us!</h4>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </section>

        </>
    )
}

export default IVRMainContent